
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M62.24 12.143c-1.186-1.355-2.877-2.102-4.76-2.102H43.255V1.875C43.256.839 42.417 0 41.381 0H31.34c-1.036 0-1.875.84-1.875 1.875v8.166h-17.54l-.458-3.437C10.973 2.901 8.395 0 5.597 0H2.25a1.875 1.875 0 100 3.75h3.347c.602 0 1.876 1.272 2.153 3.35l5.367 40.255c.236 1.774 1.148 3.435 2.567 4.677a7.749 7.749 0 003.598 1.79 6.85 6.85 0 00-.832 3.282A6.903 6.903 0 0025.346 64a6.904 6.904 0 006.896-6.896 6.848 6.848 0 00-.763-3.145h9.825a6.848 6.848 0 00-.763 3.145A6.904 6.904 0 0047.438 64a6.903 6.903 0 006.895-6.896 6.854 6.854 0 00-.762-3.145h4.912a1.875 1.875 0 000-3.75H20.66c-1.832 0-3.584-1.535-3.826-3.35l-.393-2.943h37.021c1.79 0 3.557-.684 4.976-1.925 1.419-1.242 2.33-2.904 2.568-4.678l2.689-20.171c.249-1.868-.267-3.643-1.454-4.999zM28.493 57.104a3.15 3.15 0 01-3.146 3.146 3.15 3.15 0 01-3.146-3.146 3.15 3.15 0 013.146-3.145 3.15 3.15 0 013.146 3.145zm22.091 0a3.15 3.15 0 01-3.145 3.146 3.15 3.15 0 01-3.146-3.146 3.15 3.15 0 013.145-3.145 3.15 3.15 0 013.147 3.145zM33.216 3.75h6.291v18.208c0 1.036.84 1.876 1.875 1.876h.661l-5.57 5.525-5.57-5.526h.438c1.036 0 1.875-.84 1.875-1.874V3.75zm26.762 12.895L57.29 36.817c-.243 1.815-1.995 3.35-3.827 3.35h-37.52L12.424 13.79h17.04v6.293H26.35a1.875 1.875 0 00-1.32 3.206L35.152 33.33c.366.363.843.544 1.32.544.478 0 .956-.181 1.321-.544L47.916 23.29a1.875 1.875 0 00-1.32-3.206h-3.34V13.79H57.48c.787 0 1.476.293 1.94.822.463.53.661 1.252.557 2.032z"}})])
          )
        }
      }
    